import { gql } from "@apollo/client";

export const CHANGE_APP_FEATURE_STATUS = gql`
mutation ChangeAppFeatureStatus($name: String!){
  changeAppFeatureState(featureName: $name) {
    id,
    name,
    description,
    state,
    startAt,
    endAt
  }
}`